import axiosInstance from "./axiosInstanceV1";

/**
 * Activity API — single fire-and-forget endpoint for user-activity events.
 *
 * Server-side this enqueues a row onto the bodhi:stream:logs Redis queue, which
 * worker-logger persists to BunnyDB `db_logs_user_activity`. Failures here
 * should never disrupt the user; callers should swallow rejections.
 *
 * @param {Object} event
 * @param {string} event.kind            e.g. "session_start", "auth.login", "view.album"
 * @param {string} event.session_id      browser session ULID (from activityStore)
 * @param {string} [event.entity_type]   "album" | "media" | "playlist" | "tag" | ...
 * @param {string} [event.entity_id]
 * @param {string} [event.path]          window.location.pathname at event time
 * @param {Object} [event.metadata]      ad-hoc JSON payload
 * @returns {Promise<void>}
 */
export const recordActivity = async (event) => {
	await axiosInstance.post("/user/activity", event);
};
